<template>
  <div>
    <h2>Abdomen</h2>
    <v-container v-if="!loading" class="py-10">
      <v-row>
        <v-col v-for="item in abdomen" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
          <v-checkbox
              v-model="abdomenCheckbox"
              :disabled="disableAbdomen(item.id, item.is_normal)"
              :label='item.name'
              :value="item.id"
              hide-details
              @change="toggle => abdomenTick(item.id, toggle, item.is_normal)"
          />
        </v-col>
      </v-row>
      <v-row v-if="isAbdomenRemark">
        <v-col>
          <v-text-field
              placeholder="Other"
              outlined
              v-model="abdomen_remark"
              :rules="[v => !!v || 'Abdomen Other is required']"
              label="Abdomen Other"
              @keyup="includeAbdomenRemark"
              required
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
          :size="150"
          color="primary"
          indeterminate
          style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Abdomen",

  props: {
    formData: {
      type: Object,
      required: true,
    },
    config: Number
  },

  data() {
    return {
      isAbdomenRemark: false,
      abdomen_remark: null,
      isAbdomenNormal: false,
      abdomen: {},
      loading: true,
      abdomenCheckbox: []
    }
  },

  methods: {
    editFieldAbdomen() {
      let vm = this;
      _.forEach(this.formData.physical_examination.abdomen, function (value) {
        vm.abdomenCheckbox.push(Number.parseInt(value.abdomen_id));
        if (value.abdomen_remark) {
          vm.abdomen_remark = value.abdomen_remark;
          vm.isAbdomenRemark = true;
        }
      });
    },

    disableAbdomen(id, normal = 0, toggle = true) {
      let vm = this;
      _.forEach(this.formData.physical_examination.abdomen, function (value) {
        if (Number.parseInt(value.abdomen_id) === Number.parseInt(id) && normal && toggle) {
          vm.isAbdomenNormal = true;
        }
      });
      return this.abdomenCheckbox.indexOf(id) === -1 && this.isAbdomenNormal;
    },

    abdomenTick(key, toggle, is_normal) {
      let toggled = toggle.includes(key);
      let abdomen = this.formData.physical_examination.abdomen;

      if (key === this.config) {
        this.isAbdomenRemark = !this.isAbdomenRemark;
      }
      if (is_normal) {
        this.isAbdomenNormal = !this.isAbdomenNormal;
        this.abdomenNormalOnly(key, toggled);
        this.disableAbdomen(key, is_normal, toggled);
      }

      if (toggled) {
        abdomen.push({
          abdomen_id: key,
          abdomen_remark: null,
        });
      } else {
        let index = abdomen.findIndex(abdomen => abdomen.abdomen_id === key);
        abdomen.splice(index, 1);
      }
    },

    abdomenNormalOnly(key, toggled) {
      if (toggled) {
        let abdomen = this.formData.physical_examination.abdomen;
        abdomen.push({
          abdomen_id: key,
          abdomen_remark: null,
        });
        this.abdomenCheckbox = [key];
        abdomen.splice(0, abdomen.length);
        this.isAbdomenRemark = false;
      }
    },

    includeAbdomenRemark() {
      let abdomen = this.formData.physical_examination.abdomen;
      let index = abdomen.findIndex(abdomen => abdomen.abdomen_id === this.config);
      abdomen.splice(index, 1);
      abdomen.push({
        abdomen_id: this.config,
        abdomen_remark: this.abdomen_remark,
      });
    },

    getAbdomenLib() {
      this.axios.get('abdomen-lib', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
        }
      }).then((response) => {
        // handle success
        this.abdomen = response.data;
        this.loading = false;
      }).catch((error) => {
        // handle error
        console.error(error);
      }).finally(() => {
        // always executed
      });
    },
  },

  mounted() {
    this.getAbdomenLib();
    this.editFieldAbdomen();
  }
}
</script>

<style scoped>

</style>